<template>
  <div class="rule-wrapper">
    <div class="container">
      <h1></h1>
      <h1>RULES OF THE GAME – NUMBER GAME</h1>
      <button type="button" class="collapsible">1. NUMBER GAME 75 BALLS</button>
      <div class="content" style="display: block">
        <div id="Rules" class="tabcontent1 rulesContent" style="display: block">
          <div class="rulesContent">
            <ul class="listSummary">
              <li>
                <p>
                  Number Game operates 24/7, and you can join the game by placing a bet on
                  any number written on the balls drawn from a bingo blower machine. A
                  total of 75 balls are numbered from 1 to 75.
                </p>
              </li>
              <li><p>There will be 3 balls drawn in one game</p></li>
              <li>
                <p>
                  The balls will be returned to the Bingo machine after each game to start
                  a new game.
                </p>
              </li>
              <li>
                <p>
                  There are 38 balls belonging to "Over" and 37 balls belonging to
                  "Under".
                </p>
              </li>
              <li>
                <p>
                  There are 38 balls belonging to "Odd" and 37 balls belonging to "Even".
                </p>
              </li>
              <li>
                <p>
                  There are 38 balls belonging to "Red" and 37 balls belonging to "Blue".
                </p>
              </li>
            </ul>
            <h3>Running Games (Live)</h3>
            <ul class="listDetail">
              <li>
                <h5>Next Over/Under</h5>
                <p>Predict the "Over/Under" result of the next ball.</p>
              </li>
              <li>
                <h5>Next Odd/Even</h5>
                <p>Predict the "Odd/Even" result of the next ball.</p>
              </li>
              <li>
                <h5>Next Red/Blue</h5>
                <p>Predict the "Red/Blue" result of the next ball.</p>
              </li>
              <li>
                <h5>Next Combo:</h5>
                <p><strong>Over/Odd , Under/Odd, Over/ Even, Under/ Even</strong></p>
                <p>
                  Predict the result of "Over/Odd", "Under/Odd", "Over/Even", or "Under/Even".
                </p>
                <p>
                  Example: If the ball drawn is 30, and the player has bet on "Under/Even", they win. All other bets lose.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button type="button" class="collapsible">2. NUMBER GAME 35 BALLS</button>
      <div class="content" style="display: block">
        <div id="Rules" class="tabcontent1 rulesContent" style="display: block">
          <div class="rulesContent">
            <ul class="listSummary">
              <li>
                <p>
                  The number game operates 24/7, and you can join by placing a bet on any number written
                  on the balls that will be drawn from the bingo blower machine.
                  A total of 35 balls are numbered from 1 to 35.
                </p>
              </li>
              <li><p>Three balls will be drawn in each round (game).</p></li>
              <li>
                <p>
                  After each game, the balls are returned to the Bingo machine to start a new game.
                </p>
              </li>
              <li>
                <p>
                  There are 18 balls classified as "Over" and 17 balls classified as "Under".
                </p>
              </li>
              <li>
                <p>
                  There are 18 balls classified as "Odd" and 17 balls classified as "Even".
                </p>
              </li>
              <li>
                <p>
                  There are 18 balls classified as "Red/Đỏ" and 17 balls classified as "Blue".
                </p>
              </li>
            </ul>
            <h3>Running Games (Live)</h3>
            <ul class="listDetail">
              <li>
                <h5>Next Over/Under</h5>
                <p>Predict the result of the next ball as Over or Under</p>
              </li>
              <li>
                <h5>Next Odd/Even</h5>
                <p>Predict the result of the next ball as Odd or Even</p>
              </li>
              <li>
                <h5>Next Red/Blue</h5>
                <p>Dự đoán kết quả "Đỏ/ Xanh" của quả bóng tiếp theo.</p>
              </li>
              <li>
                <h5>Next Combo:</h5>
                <p><strong>Over/Odd , Under/Odd, Over/ Even, Under/ Even</strong></p>
                <p>
                  Predict the result of combinations such as Over/Odd, Under/Odd, Over/Even, or Under/Even.
                </p>
                <p>
                  Example: If the ball drawn is 16, and the player placed a bet on Under/Even, they will win. All other bets will lose.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button type="button" class="collapsible">3. TERMS &amp; CONDITIONS</button>
      <div class="content" style="display: block">
        <div id="Rules" class="tabcontent1 rulesContent" style="display: block">
          <div class="rulesContent">
            <ol style="padding-left: 16px">
              <li>NUMBER GAME applies only to registered members.</li>
              <li>
                The results of all NUMBER GAME rounds will be displayed immediately on the results history report
                and serve as the official information.
              </li>
              <li>
                The Game Provider reserves the right to cancel or invalidate any draw or affected bets in the event of technical issues, or malfunctions of any kind, including but not limited to software errors, hardware failures, or connectivity issues.
              </li>
              <li>
                The Game Provider reserves the right to cancel or invalidate any draw or affected bets
                if there is any suspicion that a player is engaging in fraudulent activities, collusion, or other illegal actions.
              </li>
              <li>
                The Game Provider reserves the right to cancel or invalidate any draw or affected bets in the event of an error
                (due to incorrect input by the Game Provider's administrator) or a system malfunction that results
                in incorrect odds being used for NUMBER GAME.
              </li>
              <li>
                Bets that have been accepted and accompanied by a Draw ID in the final confirmation notice will remain valid,
                even if the member subsequently logs out or is disconnected from the game for any reason, such as poor connectivity, disconnection, etc.
              </li>
              <li>
                The Betting Ticket Number serves as a reference number for all bets placed and successfully confirmed.
                The Betting Ticket Number represents a valid bet.
                In the event that no Betting Ticket Numbers are generated after placing a bet,
                it means that the bet was unsuccessful and invalid.
                Therefore, avoid placing repeat bets or multiple transactions in the final seconds of the current draw.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  head() {
    return {
      title: "rule",
    };
  },
};
</script>

<style>
body,
#app {
  background: #45464e url(/images/kenobg.jpg) no-repeat fixed;
  color: #fff;
  font-size: 1rem;
}
h1,
h2 {
  /* color: #161c2d; */
  font-size: 24px;
  font-weight: 500;
  margin: 20px 0 30px;
}

h3 {
  font-size: 20px;
  margin: 0;
  padding: 10px 0;
}

thead {
  color: black;
}
ol {
  text-align: left;
}

table {
  border: 1px solid #292a2e;
}

td {
  vertical-align: top;
  padding: 0.1in 5.75pt;
}

.rule-wrapper {
  text-align: left;
  /* padding: 80px 0; */
}
.rule-wrapper a {
  color: #1652f0;
  text-decoration: none;
}

.tablestyle {
  border-spacing: 0;
  border-collapse: separate !important;
  width: 100%;
  text-align: center;
}

.tablestyle thead th {
  background: #37405a;
  color: #b0bfd3;
  font-weight: normal;
  /*border-left: 1px solid #4A82F0;
    border-bottom: 1px solid #4A82F0;*/
}

.tablestyle th,
.tablestyle td {
  padding: 2px 10px;
  background: #fff;
  color: #4d4f5c;
}

.tablestyle .currency {
  text-align: right;
}

.tablestyle tbody tr td {
  vertical-align: top;
}

.tablestyle tbody tr:nth-of-type(2n + 0) td {
  background: #f2f6fe;
}

.input-group .form-control {
  border: 0;
}

.input-group-text {
  background: #fff;
  border: 0;
  line-height: normal;
}
.pull-right {
  float: right;
}

.resulticon {
  margin: 0 auto;
  display: block;
  font-size: 10px;
  background-color: #999;
  text-align: center;
  height: 18px;
  width: 18px;
  line-height: 18px;
  border-radius: 18px;
  cursor: pointer;
  color: #fff;
  font-weight: bold;
}

h5 {
  background: #292a2e;
  color: #fff;
  line-height: 50px;
  height: 50px;
  width: 100%;
}

.paragraphy-style {
  text-align: left;
  padding-left: 16px;
  padding-right: 16px;
}

.tablestyle td,
.tablestyle th {
  padding: 10px;
}

.tablecont {
  padding-left: 16px;
  padding-right: 16px;
}

.table-border {
  border-bottom: 1px solid #e3ecfe;
}

@media screen and (max-width: 480px) {
  .tablestyle td,
  .tablestyle th {
    padding: 5px;
    border-right: 1px solid #37405a;
  }
}

/* Style the tab */
.tab {
  overflow: hidden;
  width: inherit;
  /* filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr='#FDFCFC', endColorstr='#FBF9F9'); */
}

/* Style the buttons inside the tab */
.tab button {
  float: left;
  margin: 0;
  background-color: #f2f0f0;
  border: 1px solid #c0c0c0;
  color: #444;
  text-shadow: 0 1px #eee;
  outline: none;
  height: 100%;
  cursor: pointer;
  padding: 14px;
  width: 50%;
  transition: 0.3s;

  font-family: sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 16px;
  /* background-image: linear-gradient(top, #FDFCFC, #FBF9F9 50%, #F7F5F6 50%, #F2F0F0);  */
  background-image: -webkit-linear-gradient(
    top,
    #fdfcfc,
    #fbf9f9 50%,
    #f7f5f6 50%,
    #f2f0f0
  );
  /* display: inline-block; */
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: white;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: white !important;
  background-image: -webkit-linear-gradient(top, white, white 50%, white 50%, white);
  border-bottom: none;
}

/* Style the tab content */
.tabcontent1,
.tabcontent2,
.tabcontent3 {
  text-align: left;
  display: none;
  border: 1px solid #ccc;
  border-top: none;
  animation: fadeEffect 1s;
  padding: 20px;
}

.center {
  text-align: center;
}
.table-payout {
  text-align: center;
  width: 100%;
}
.container-center {
  text-align: -webkit-center;
}
.left {
  text-align: left;
}
.list-bet {
  text-align: center;
  padding: 0.1in 5.75pt;
}
.list-bet tr td:nth-child(2) {
  /* I don't think they are 0 based */
  text-align: left;
  padding: 0.1in 5.75pt;
}
.list-bet tr td:nth-child(4),
.list-bet tr td:nth-child(6) {
  /* I don't think they are 0 based */
  text-align: left;
  padding: 0.1in 5.75pt;
}

/* Go from zero to full opacity */
@keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
button {
  border-radius: 0;
}
.collapsible {
  color: black !important;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border-bottom: none;
  border: 1px solid #c0c0c0;
  text-align: left;
  outline: none;
  font-family: sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 18px;
  background-image: -webkit-linear-gradient(
    top,
    #fdfcfc,
    #fbf9f9 50%,
    #f7f5f6 50%,
    #f2f0f0
  );
  position: relative;
}

.active,
.collapsible:hover {
  background-image: -webkit-linear-gradient(top, white, white 50%, white 50%, white);
}

td {
  border: 1pt solid;
}
.content {
  display: none;
  overflow: hidden;
  background-color: #45464e;
}

@media (max-width: 540px) {
  button {
    font-size: 13px !important;
  }
}

.top-navbar {
  text-align: center;
  background: #292a2e;
  line-height: 50px;
  height: 50px;
  width: 100%;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.back-arrow {
  color: #fff;
  font-size: 24px;
  float: left;
  height: 24px;
  line-height: 24px;
  position: absolute;
  left: 4px;
  top: 14px;
}

.back-arrow:hover {
  color: #fff;
  text-decoration: none;
}

.gli {
  text-align: center;
}

.gli a {
  text-decoration: underline;
}
</style>

<style lang="scss" scoped>
.listSummary {
  margin-bottom: 20px;
}

.rulesContent ul,
.rulesContent ol {
  padding-left: 35px;
}

.rulesContent p {
  margin-bottom: 10px;
}

.rulesContent .listDetail {
  padding-left: 17px;
}

.rulesContent h5 {
  background: none;
}
</style>
